<div class="card">
  <app-header titulo="Exclusão de Materiais na Integração" descricao="Materiais que serão ignorados na integração de transferência de insumos"></app-header>

  <p-table [value]="registros" dataKey="publicId" [loading]="loading" #dt
           [lazy]="true" (onLazyLoad)="onLazyLoad($event)"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <button pButton icon="pi pi-plus" label="Novo Cadastro" class="p-button-success"
                (click)="abrirNovo()"></button>
        <span class="ml-auto">
          <button pButton pRipple icon="pi pi-refresh" (click)="recarregar()" [loading]="loading"></button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="codigoMaterial">Código do Material <p-sortIcon field="codigoMaterial"/></th>
        <th>Status</th>
        <th pSortableColumn="criadoEm">Criado em <p-sortIcon field="criadoEm"/></th>
        <th>Criado por</th>
        <th>Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-registro>
      <tr>
        <td>{{ registro.codigoMaterial }}</td>
        <td>
          <p-inputSwitch [(ngModel)]="registro.ativo" (onChange)="alternarStatus(registro)"></p-inputSwitch>
        </td>
        <td>{{ registro.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ registro.criadoPor }}</td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                  (click)="abrirEdicao(registro)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                  (click)="confirmarExclusao(registro)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Nenhum registro encontrado</td>
      </tr>
    </ng-template>
  </p-table>

  <p-confirmDialog header="Confirmação" width="425"></p-confirmDialog>

  <p-dialog [(visible)]="dialogVisivel" [style]="{width: '450px'}"
            [header]="registro.publicId ? 'Editar Material Excluído' : 'Novo Material Excluído'"
            [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
      <div class="field">
        <label for="codigoMaterial">Código do Material:</label>
        <input id="codigoMaterial" pInputText type="text" [(ngModel)]="registro.codigoMaterial" class="w-full" required autofocus>
        <small class="p-error" *ngIf="enviado && !registro.codigoMaterial">Código do material é obrigatório.</small>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="fecharDialog()"></button>
      <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvar()"></button>
    </ng-template>
  </p-dialog>
</div>
